import {translate} from "react-i18nify";

import * as actionTypes from "../constants/actionTypes";
import * as filtering from "../constants/filtering";
import * as config from "../constants/config";
import * as rcc from "../constants/rcc";
import * as orderStatus from "../constants/orderStatus";
import * as reducerHelper from "../helpers/reducerHelper";
import * as modelHelper from "../helpers/modelHelper";

import Product from "../models/entities/Product";
import Fandeck from "../models/entities/Fandeck";

/**
 * Structure of object from filtering store:
 */

const initialState = {
    init: false,
    defaultProductList: [],
    defaultFandeckList: [],
    defaultFormulaList: [],
    defaultFormulaCodeList: [],
    defaultBaseList: [],
    defaultPackageList: [],
    defaultCustomerList: [],
    defaultStatusList: [],
    clientName: "",
    customProductList: [],
    customFandeckList: [],
    customFormulaList: [],
    customFormulaCodeList: [],
    customBaseList: [],
    customPackageList: [],
    customBippList: [],
    customCustomerList: [],
    selectedColorStatsTypeList: [],
    selectedProductList: [],
    selectedFandeckList: [],
    selectedFormulaList: [],
    selectedFormulaCodeList: [],
    selectedBaseList: [],
    selectedPackageList: [],
    selectedBippList: [],
    selectedCustomerList: [],
    selectedStatusList: [],
    dateFrom: null,
    dateTo: null,
    filterOperator: "",
    filterBuildingSite: "",
    filterPackageCount: "",
    filterMoreInfo: "",
    filterMoreInfoInternal: "",
    consumptionType: rcc.CONSUMPTION_TYPE_ALL
};

export const filteringReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.FILTERING_INIT:
            if (state[action.payload.tabId] === undefined) {
                return state;
            }

            return reducerHelper.getNewState(action.payload.tabId, {init: true}, state);
        case actionTypes.STATISTICS_TAB_INIT:
            if (state[action.payload.tabId] !== undefined) {
                return state;
            }

            let initDateFrom = null;
            let initDateTo = null;

            if (action.payload.dateFilter) {
                initDateFrom = new Date();
                initDateFrom.setDate(initDateFrom.getDate() - 30);
                initDateTo = new Date();
            }

            let newInitialStatsState = {};
            newInitialStatsState[action.payload.tabId] = initialState;
            newInitialStatsState[action.payload.tabId].selectedCustomerList = action.payload.customerList;
            newInitialStatsState[action.payload.tabId].dateFrom = initDateFrom;
            newInitialStatsState[action.payload.tabId].dateTo = initDateTo;

            return {...state, ...newInitialStatsState};
        case actionTypes.MY_ORDERS_TAB_INIT:
            if (state[action.payload.tabId] !== undefined) {
                return state;
            }

            let newMyOrdersState = {};
            newMyOrdersState[action.payload.tabId] = initialState;
            newMyOrdersState[action.payload.tabId].defaultStatusList = orderStatus.MY_ORDER_STATUS_LIST;

            return {...state, ...newMyOrdersState};
        case actionTypes.TO_DISPENSE_TAB_INIT:
            if (state[action.payload.tabId] !== undefined) {
                return state;
            }

            let newToDispenseState = {};
            newToDispenseState[action.payload.tabId] = initialState;
            newToDispenseState[action.payload.tabId].defaultStatusList = orderStatus.TO_DISPENSE_ORDER_STATUS_LIST;

            return {...state, ...newToDispenseState};
        case actionTypes.ORDERS_HISTORY_INIT:
        case actionTypes.PURGE_STATS_INIT:
        case actionTypes.COLORANT_REFILL_HISTORY_INIT:
            if (state[action.payload.tabId] !== undefined) {
                return state;
            }

            let newInitialState = {};
            newInitialState[action.payload.tabId] = initialState;

            return {...state, ...newInitialState};
        case actionTypes.FILTERING_SAVE_PARAMS:
            switch (action.payload.paramType) {
                case filtering.DATE_FROM:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {dateFrom: action.payload.paramValue},
                        state
                    );
                case filtering.DATE_TO:
                    return reducerHelper.getNewState(action.payload.tabId, {dateTo: action.payload.paramValue}, state);
                case filtering.COLOR_STATS_TYPE:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {selectedColorStatsTypeList: action.payload.paramValue},
                        state
                    );
                case filtering.PRODUCT:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {selectedProductList: action.payload.paramValue},
                        state
                    );
                case filtering.FANDECK:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {selectedFandeckList: action.payload.paramValue},
                        state
                    );
                case filtering.FORMULA:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {selectedFormulaList: action.payload.paramValue},
                        state
                    );
                case filtering.FORMULA_CODE:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {selectedFormulaCodeList: action.payload.paramValue},
                        state
                    );
                case filtering.BASE:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {selectedBaseList: action.payload.paramValue},
                        state
                    );
                case filtering.PACKAGE:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {selectedPackageList: action.payload.paramValue},
                        state
                    );
                case filtering.BIPP:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {selectedBippList: action.payload.paramValue},
                        state
                    );
                case filtering.OPERATOR:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {filterOperator: action.payload.paramValue},
                        state
                    );
                case filtering.BUILDING_SITE:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {filterBuildingSite: action.payload.paramValue},
                        state
                    );
                case filtering.CUSTOMER:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {selectedCustomerList: action.payload.paramValue},
                        state
                    );
                case filtering.STATUS:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {selectedStatusList: action.payload.paramValue},
                        state
                    );
                case filtering.PACKAGE_COUNT:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {filterPackageCount: action.payload.paramValue},
                        state
                    );
                case filtering.MORE_INFO:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {filterMoreInfo: action.payload.paramValue},
                        state
                    );
                case filtering.MORE_INFO_INTERNAL:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {filterMoreInfoInternal: action.payload.paramValue},
                        state
                    );
                case filtering.CONSUMPTION_TYPE:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {consumptionType: action.payload.paramValue},
                        state
                    );
                case filtering.CLIENT_NAME:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {clientName: action.payload.paramValue},
                        state
                    );
                default:
                    return state;
            }
        case actionTypes.FILTERING_SAVE_CUSTOM_PARAMS:
            switch (action.payload.paramType) {
                case filtering.PRODUCT:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {customProductList: action.payload.paramValue},
                        state
                    );
                case filtering.FANDECK:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {customFandeckList: action.payload.paramValue},
                        state
                    );
                case filtering.FORMULA:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {customFormulaList: action.payload.paramValue},
                        state
                    );
                case filtering.FORMULA_CODE:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {customFormulaCodeList: action.payload.paramValue},
                        state
                    );
                case filtering.BASE:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {customBaseList: action.payload.paramValue},
                        state
                    );
                case filtering.PACKAGE:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {customPackageList: action.payload.paramValue},
                        state
                    );
                case filtering.BIPP:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {customBippList: action.payload.paramValue},
                        state
                    );
                case filtering.CUSTOMER:
                    return reducerHelper.getNewState(
                        action.payload.tabId,
                        {customCustomerList: action.payload.paramValue},
                        state
                    );
                default:
                    return state;
            }
        case actionTypes.FILTERING_SAVE_DEFAULT_PRODUCT_LIST:
            if (state[action.payload.tabId] === undefined) {
                return state;
            }

            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    defaultProductList: modelHelper
                        .mapSimpleProductsToObjects(action.payload.productList)
                        .concat([
                            new Product(
                                0,
                                config.QUICK_TINT_NAME,
                                translate("general.quickTint"),
                                config.QUICK_TINT_NAME
                            )
                        ])
                },
                state
            );
        case actionTypes.FILTERING_SAVE_DEFAULT_FANDECK_LIST:
            if (state[action.payload.tabId] === undefined) {
                return state;
            }

            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    defaultFandeckList: modelHelper
                        .mapFandecksToObjects(action.payload.fandeckList)
                        .concat([new Fandeck(0, config.QUICK_TINT_NAME, translate("general.quickTint"))])
                },
                state
            );
        case actionTypes.FILTERING_SAVE_LOCAL_FANDECK_LIST:
            if (state[action.payload.tabId] === undefined) {
                return state;
            }

            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    defaultFandeckList: reducerHelper.mergeEntityLists(
                        state[action.payload.tabId].defaultFandeckList,
                        modelHelper.mapFandecksToObjects(action.payload.fandeckList)
                    )
                },
                state
            );
        case actionTypes.FILTERING_SAVE_DEFAULT_FORMULA_LIST:
            if (state[action.payload.tabId] === undefined) {
                return state;
            }

            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    defaultFormulaList: modelHelper
                        .mapColorsToObjects(action.payload.colorList, false)
                        .concat([
                            modelHelper.mapColorDataToObject(
                                0,
                                config.QUICK_TINT_NAME,
                                translate("general.quickTint"),
                                config.QUICK_TINT_NAME
                            )
                        ])
                },
                state
            );
        case actionTypes.FILTERING_SAVE_LOCAL_FORMULA_LIST:
            if (state[action.payload.tabId] === undefined) {
                return state;
            }

            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    defaultFormulaList: reducerHelper.mergeEntityLists(
                        state[action.payload.tabId].defaultFormulaList,
                        modelHelper.mapColorsToObjects(action.payload.colorList, true)
                    )
                },
                state
            );
        case actionTypes.FILTERING_SAVE_DEFAULT_FORMULA_CODE_LIST:
            if (state[action.payload.tabId] === undefined) {
                return state;
            }

            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    defaultFormulaCodeList: modelHelper
                        .mapColorsToObjects(action.payload.colorList, false)
                        .concat([
                            modelHelper.mapColorDataToObject(
                                0,
                                config.QUICK_TINT_NAME,
                                translate("general.quickTint"),
                                config.QUICK_TINT_NAME
                            )
                        ])
                },
                state
            );
        case actionTypes.FILTERING_SAVE_LOCAL_FORMULA_CODE_LIST:
            if (state[action.payload.tabId] === undefined) {
                return state;
            }

            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    defaultFormulaCodeList: reducerHelper.mergeColorCodeLists(
                        state[action.payload.tabId].defaultFormulaCodeList,
                        modelHelper.mapColorsToObjects(action.payload.colorList, true)
                    )
                },
                state
            );
        case actionTypes.FILTERING_SAVE_DEFAULT_BASE_LIST:
            let defaultBaseList = modelHelper.mapBasesToObjects(action.payload.baseList);

            let filteredSelectedBaseList = [];

            for (let selectedBase of state[action.payload.tabId].selectedBaseList) {
                if (defaultBaseList.some((item) => item.id === selectedBase.id)) {
                    filteredSelectedBaseList.push(selectedBase);
                }
            }

            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    defaultBaseList: defaultBaseList,
                    selectedBaseList: filteredSelectedBaseList
                },
                state
            );
        case actionTypes.FILTERING_SAVE_DEFAULT_PACKAGE_LIST:
            let defaultPackageList = modelHelper.mapBippToObjects(action.payload.packageList);

            let filteredSelectedPackageList = [];

            for (let selectedPackage of state[action.payload.tabId].selectedPackageList) {
                if (defaultPackageList.some((item) => item.id === selectedPackage.id)) {
                    filteredSelectedPackageList.push(selectedPackage);
                }
            }

            let filteredSelectedBippList = [];

            for (let selectedPackage of state[action.payload.tabId].selectedBippList) {
                if (defaultPackageList.some((item) => item.id === selectedPackage.id)) {
                    filteredSelectedBippList.push(selectedPackage);
                }
            }

            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    defaultPackageList: defaultPackageList,
                    selectedPackageList: filteredSelectedPackageList,
                    selectedBippList: filteredSelectedBippList
                },
                state
            );
        case actionTypes.FILTERING_SAVE_DEFAULT_CUSTOMER_LIST:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {defaultCustomerList: modelHelper.mapCustomersToObjects(action.payload.customerList)},
                state
            );
        case actionTypes.CLOSE_ACTIVE_TAB:
        case actionTypes.CLOSE_ALL_TABS_EXCEPT_ACTIVE:
        case actionTypes.CLOSE_ALL_TABS:
            let finalState = {};

            let tab;
            for (tab of action.payload.newTabList) {
                if (state[tab.id] !== undefined) {
                    finalState[tab.id] = state[tab.id];
                }
            }

            return finalState;
        case actionTypes.PURGE_STATS_EXIT:
        case actionTypes.COLORANT_REFILL_HISTORY_EXIT:
            let finalStatePurgeStats = {};

            let tabId;
            for (tabId of Object.keys(state)) {
                if (Number(tabId) !== action.payload.tabId) {
                    finalStatePurgeStats[tabId] = state[tabId];
                }
            }

            return finalStatePurgeStats;
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.DATABASE_CHANGE:
            return {};
        default:
            return state;
    }
};
